export let store: any;

export function setSharedStore(sharedStore: any) {
    store = sharedStore;
}
